// extracted by mini-css-extract-plugin
export default {"circles":"styles_circles__MWZe0","animate":"styles_animate__OFkNO"};